import { render, staticRenderFns } from "./monitor-center-alert.vue?vue&type=template&id=9ae1bb36&scoped=true"
import script from "./monitor-center-alert.vue?vue&type=script&lang=js"
export * from "./monitor-center-alert.vue?vue&type=script&lang=js"
import style0 from "./monitor-center-alert.vue?vue&type=style&index=0&id=9ae1bb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae1bb36",
  null
  
)

export default component.exports